import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNext = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 12 11",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M6.40039 1L10.9004 5.5L6.40039 10M1.00039 1L5.50039 5.5L1.00039 10",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.44
}));
const ForwardRef = forwardRef(SvgArrowNext);
export default ForwardRef;
